import AuthService from "../../utils/auth/Auth.service";
import { STORAGE_NAME_ACCESS_TOKEN } from "../../utils/constantes";
import * as GeneralProvider from "../providers/general-provider";

const normalizeDistritoItem = (distrito) => {
    return {
        ubigeo: distrito.ubigeo,
        departmentCode: distrito.departmentCode !== undefined ? distrito.departmentCode : distrito.codigoDepartamento,
        provinceCode: distrito.provinceCode !== undefined ? distrito.provinceCode : distrito.codigoProvincia,
        districtCode: distrito.districtCode !== undefined ? distrito.districtCode : distrito.codigoDistrito,
        department: distrito.department !== undefined ? distrito.department : distrito.departamento,
        province: distrito.province !== undefined ? distrito.province : distrito.provincia,
        district: distrito.district !== undefined ? distrito.district : distrito.distrito
    }
}

const normalizeDistritosResponse = (entity) => {
    const distritos = Array.isArray(entity)
        ? entity
        : Array.isArray(entity?.datos)
            ? entity.datos
            : []

    return distritos.map(normalizeDistritoItem)
}

export const renovarToken = async () => {
    const authService = new AuthService()
    const renewToken = await authService.renewToken();

    if(renewToken) { 
        const {accessToken} = renewToken;
        localStorage.setItem(STORAGE_NAME_ACCESS_TOKEN, accessToken);
        return {
            error: null,
            token: accessToken
        };
        
    } else {
        return null
    }
}

export const obtenerAccessToken = async () => {
    const response = await GeneralProvider.obtenerAccessToken()
    if(response.auditResponse.codigoRespuesta === '0') {
        localStorage.setItem("access.token", response.entity.access_token)
        return {
            error: null,
            token: response.entity
        }
    } else {
        return {
            error: response.auditResponse,
            token: null
        }
    }
}

export const obtenerTablasMaestras = async () => {
    const response = await GeneralProvider.obtenerTablasMaestras()
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            tablasMaestras: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await renovarToken();
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerTablasMaestras()
            } else {
                return {
                    error: response.auditResponse,
                    tablasMaestras: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                tablasMaestras: null
            }
        }
    }
}

export const obtenerTablaMaestraCodigo = async (codigoTabla) => {
    const response = await GeneralProvider.obtenerTablaMaestraCodigo(codigoTabla)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            tablaMaestra: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerTablaMaestraCodigo(codigoTabla)
            } else {
                return {
                    error: response.auditResponse,
                    tablaMaestra: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                tablaMaestra: null
            }
        }
    }
}

export const obtenerPersonID = async (numeroDocumento) => {
    const response = await GeneralProvider.obtenerPersonID(numeroDocumento)
    if(response.auditResponse.codigoRespuesta === '1') {
        return {
            error: null,
            persona: response.Entity
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerPersonID(numeroDocumento)
            } else {
                return {
                    error: response.auditResponse,
                    persona: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                persona: null
            }
        }
    }
}

export const obtenerListarDistritos = async () => {
    let response = await GeneralProvider.obtenerListaDistritos()
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            listaDistritos: normalizeDistritosResponse(response.entity)
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerListarDistritos()
            } else {
                return {
                    error: response.auditResponse,
                    listaDistritos: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                listaDistritos: null
            }
        }
    }
}

export const validarPersonID = async (idSolicitudMultiple, solicitudes) => {
    let codigosSolicitud = ''
    for(let i = 0; i < solicitudes.length; i++) {
        codigosSolicitud = codigosSolicitud + (i !== 0 ? ',' : '') + solicitudes[i].idSolicitud
    }
    const response = await GeneralProvider.validarPersonID(idSolicitudMultiple, codigosSolicitud)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            validacion: response.Entity
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await validarPersonID(idSolicitudMultiple, solicitudes)
            } else {
                return {
                    error: response.auditResponse,
                    validacion: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                validacion: null
            }
        }
    }
}

export const obtenerParametros = async () => {
    const response = await GeneralProvider.obtenerParametros()
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            parametros: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerParametros()
            } else {
                return {
                    error: response.auditResponse,
                    parametros: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                parametros: null
            }
        }
    }
}

export const obtenerValidacionPersonas = async (tipoDoc, numeroDoc) => {
    const response = await GeneralProvider.validarPersonas(tipoDoc, numeroDoc)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            personas: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerValidacionPersonas(tipoDoc, numeroDoc)
            } else {
                return {
                    error: response.auditResponse,
                    personas: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                personas: null
            }
        }
    }
}

export const obtenerEntidadesFinancieras = async () => {
    const response = await GeneralProvider.obtenerEntidadesFinancieras()

    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            entidades: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerEntidadesFinancieras()
            } else {
                return {
                    error: response.auditResponse,
                    entidades: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                entidades: null
            }
        }
    }
}